import React from 'react';
import { LearningPathPage } from './components/LearningPathPage';

import './index.scss';

export default function LearningPaths() {
  return <LearningPathPage />;
}
